
import { defineComponent, computed, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { debounce } from '@/utils/debounce'

export default defineComponent({
  name: 'ClientRegisteInfoModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['closeClientModal', 'registeInfo'],
  setup(props, context) {
    const { t, locale } = useI18n()
    const data = reactive({
      info: ''
    })
    const modalVisiable = computed(() => props.show)

    /** 按当前语言展示对应的注册信息预览图 */
    const registeInfoMessageDialogImages: Record<string, string> = {
      'zh-CN': require('./_images/zh-CN/registe_info_message_dialog.png'),
      'zh-TW': require('./_images/zh-TW/registe_info_message_dialog.png'),
      'en-US': require('./_images/en-US/registe_info_message_dialog.png'),
      'ja-JP': require('./_images/ja-JP/registe_info_message_dialog.png'),
    }
    const registeInfoMessageDialogPic = computed(
      () => registeInfoMessageDialogImages[locale.value] || registeInfoMessageDialogImages['zh-CN']
    )

    const inputRules = debounce(() => {
      // eslint-disable-next-line no-magic-numbers
      if (data.info.length > 30) {
        ElMessage({
          message: t('groupClient.registerInfoModalMsgTooLong'),
          type: 'warning'
        })
      }
    })

    return {
      ...toRefs(data),
      modalVisiable,
      registeInfoMessageDialogPic,
      closeModal() {
        context.emit('closeClientModal', 'MODAL_CLIENT_REGISTE_INFO')
      },
      submitInfo() {
        context.emit('registeInfo', data.info)
        context.emit('closeClientModal', 'MODAL_CLIENT_REGISTE_INFO')
      },
      inputRules,
    }
  }
})
